import getPartnerAsset, { DynamicAssetsKeys } from 'packages/smart-home-support/assets';
import { ctaProps } from 'packages/smart-home-support/constants';
import { PartnerContent } from 'packages/smart-home-support/partner';
import React, { ElementType, ReactElement } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { NAV_HEIGHT_DESKTOP, NAV_HEIGHT_MOBILE } from '../../../../components/Header/constants';
import BREAK_POINTS from '../../../../styling/media-queries';
import { CallToAction } from '../../../../styling/styles';
import TCHHero from './TCHHero';

const HeroButton = styled(Link)`
  ${CallToAction}
  margin: 25px;
  font-weight: 600;
  background-color: ${(props) => props.theme.colors.heroButtonBackground || props.theme.colors.primaryAccent};
  ${(props) => (props.theme.colors.heroButtonFont ? `color: ${props.theme.colors.heroButtonFont}` : '')};
  text-transform: ${(props) => props.theme.styles.callToActionTextTransform};
`;

const HeroContainer = styled.div`
  display: flex;
  height: calc(100vh - ${NAV_HEIGHT_MOBILE}px - 25px);
  max-height: 1200px;
  width: 100%;

  @media ${BREAK_POINTS.desktop} {
    height: calc(100vh - ${NAV_HEIGHT_DESKTOP}px - 35px);
  }
`;

const HeroContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  text-align: center;

  height: 100%;
`;

type HeroProps = {
  header: string | JSX.Element;
  imageUrl: string;
  subtitle: string | JSX.Element;
  linkText: string | JSX.Element;
  linkComponent?: Function;
};

const ContentFrame = styled.div`
  padding: 15px;
  margin-bottom: 10px;
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${BREAK_POINTS.mobileBig} {
    width: 80%;
  }

  @media ${BREAK_POINTS.desktop} {
    max-width: 1200px;
  }
`;

const HeroTitle = getPartnerAsset<ElementType>(DynamicAssetsKeys.homeHeroTitleComponent);
const HeroSubtitle = getPartnerAsset<ElementType>(DynamicAssetsKeys.homeHeroSubtitleComponent);
const HeroImageContainer = getPartnerAsset<ElementType<{ imageUrl: string }>>(
  DynamicAssetsKeys.homeHeroImageContainerComponent
);
const HeroContentSpacer = getPartnerAsset<ElementType>(DynamicAssetsKeys.homeHeroSpacerComponent);

const HeroSection: React.SFC<HeroProps> = (props: HeroProps) => {
  const HeroLink: any = props.linkComponent ? props.linkComponent : HeroButton;

  return (
    <HeroContainer>
      <HeroImageContainer imageUrl={props.imageUrl}>
        <HeroContentContainer>
          <HeroContentSpacer />
          <ContentFrame>
            <HeroTitle>{props.header}</HeroTitle>
            <HeroSubtitle>{props.subtitle}</HeroSubtitle>
            <PartnerContent TechCoachHome="" Verizon="">
              <HeroLink {...ctaProps}>{props.linkText}</HeroLink>
            </PartnerContent>
          </ContentFrame>
        </HeroContentContainer>
      </HeroImageContainer>
    </HeroContainer>
  );
};

const productName = getPartnerAsset<string>(DynamicAssetsKeys.productName);
const header = getPartnerAsset<ReactElement>(DynamicAssetsKeys.homeHeroTitle);
const coverImage = getPartnerAsset<string>(DynamicAssetsKeys.homeHeroImage);
const subtitle = getPartnerAsset<ReactElement>(DynamicAssetsKeys.homeHeroSubtitle);

const Hero = () => (
  <PartnerContent TechCoachHome={<TCHHero />}>
    <HeroSection header={header} imageUrl={coverImage} subtitle={subtitle} linkText={`Join ${productName}`} />
  </PartnerContent>
);

export default Hero;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/homepage/components/Hero/Hero.tsx